import { createRouter, createWebHistory } from 'vue-router'
import PageRefactored from '@/components/PageRefactored.vue'

const SUPPORTED_LOCALES = ['ar', 'en']
const DEFAULT_LOCALE = 'ar'

const routes = [
  {
    path: '/',
    redirect: () => {
      const saved = (typeof localStorage !== 'undefined' && localStorage.getItem('locale')) || DEFAULT_LOCALE
      const lang = SUPPORTED_LOCALES.includes(saved) ? saved : DEFAULT_LOCALE
      return `/${lang}`
    }
  },
  {
    path: '/:lang(ar|en)',
    name: 'home',
    component: PageRefactored,
    props: true
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: `/${DEFAULT_LOCALE}`
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
